import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable, pipe, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { MessageService } from "../message.service";

@Injectable()
export class ErrorHttpInterceptor implements HttpInterceptor {
  constructor(
    private messageService: MessageService,
    private translateService: TranslateService
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      pipe(
        catchError((err: HttpErrorResponse) => {
          if (err instanceof HttpErrorResponse) {
            switch (err.status) {
              case 0:
                this.messageService.publishError(
                  this.translateService.instant("ServerUnavailable")
                );
                break;
              /*case 401:
                // User don't need to be informed on this endpoint because its handled internally
                if (
                  !(
                    req.url.toLowerCase().includes("api/users/me") ||
                    req.url.toLowerCase().includes("api/users/login")
                  )
                ) {
                  this.messageService.publishError(
                    this.translateService.instant("Error401")
                  );
                }
                break;**/
              case 403:
                this.messageService.publishError(
                  this.translateService.instant("Error403")
                );
                break;
              case 404:
                // User don't need to be informed on this endpoint because its handled internally
                if (!req.url.toLowerCase().includes("api/users/me")) {
                  this.messageService.publishError(
                    this.translateService.instant("Error404")
                  );
                }
                break;
              case 409:
                if (req.method === "POST" || req.method === "PATCH") {
                  this.messageService.publishError(
                    this.translateService.instant("Error409")
                  );
                }
                break;
              case 500:
                this.messageService.publishError(
                  this.translateService.instant("Error500")
                );
                break;
              default:
                // this.messageService.publishError(
                //   `${err.status}: ${err.statusText}`
                // );
                break;
            }
          }
          return throwError(err);
        })
      )
    );
  }
}
